import * as React from 'react';
import { observer } from '../../../mobx-exports';
const SpacerNode = () => React.createElement("g", null);
export default observer(SpacerNode);
//# sourceMappingURL=SpacerNode.js.map